import { createFileRoute, useParams } from "@tanstack/react-router";

import { EditAudience } from "@/features/Audiences/EditAudience";

export const Route = createFileRoute("/_auth/people/$siteId/audiences/new")({
  component: NewAudiencePage,
});

function NewAudiencePage() {
  const { siteId } = useParams({ from: "/_auth/people/$siteId/audiences/new" });
  return <EditAudience siteId={siteId} />;
}
